// extracted by mini-css-extract-plugin
export default {"spacerw":"shared-global-styles_spacerw__aoUyV","button":"shared-global-styles_button__enZ2n"};